// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  padding: 20px 12px;
}
.main-container mat-form-field {
  width: 100%;
}

.superior {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.iconos-superior {
  width: 25%;
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px;
}

.iconos-superior mat-icon {
  cursor: pointer;
}

.inputNuevo {
  border-bottom: 2px solid #cecece;
}

.slideAdministrar {
  margin-bottom: 10px;
  font-weight: 500;
}

.deshabilitar {
  cursor: nw-resize;
  color: #666666;
  pointer-events: none;
}

.requerimientos {
  width: 100%;
  padding-left: 8px;
}

.requerimientos ul li {
  list-style: none;
}

.text-green {
  color: #32ac44 !important;
}

.text-red {
  color: #f44336;
}`, "",{"version":3,"sources":["webpack://./src/app/dialogs/modificar-usuario/modificar-usuario.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,WAAA;AACR;;AAGA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,UAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,gCAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,cAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ","sourcesContent":[".main-container {\r\n    padding: 20px 12px;\r\n\r\n    mat-form-field {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.superior {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.iconos-superior {\r\n    width: 25%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 0 0 20px;\r\n}\r\n\r\n.iconos-superior mat-icon {\r\n    cursor: pointer;\r\n}\r\n\r\n.inputNuevo {\r\n    border-bottom: 2px solid #cecece;\r\n}\r\n\r\n.slideAdministrar {\r\n    margin-bottom: 10px;\r\n    font-weight: 500;\r\n}\r\n\r\n.deshabilitar{\r\n    cursor: nw-resize;\r\n    color: #666666;\r\n    pointer-events:none;\r\n}\r\n\r\n.requerimientos {\r\n    width: 100%;\r\n    padding-left: 8px;\r\n}\r\n\r\n.requerimientos ul li {\r\n    list-style: none;\r\n}\r\n\r\n.text-green {\r\n    color: #32ac44 !important;\r\n}\r\n\r\n.text-red {\r\n    color: #f44336;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
